<template>
  <div>
    <h2 class="mb-2">
      {{ label }}
    </h2>
    <v-layout>
      <v-menu
        v-model="menu"
        class="mb-2"
        :close-on-content-click="false"
        :close-on-click="false"
        :nudge-width="400"
        offset-x
      >
        <v-btn
          slot="activator"
          small
          :data-test="`${dataTest}Select`"
        >
          Выбрать
        </v-btn>
        <v-card>
          <v-card-text>
            <app-reference
              v-model="selected"
              :label="searchPlaceholder"
              :resource="resource"
              :component-name="referenceComponent"
              @click="close"
              @input="add"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              flat
              @click="close"
            >
              Отмена
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <ReferenceAddButton
        :label="label"
        :resource="resource"
        :component-name="referenceComponent"
        :data-test="dataTest"
        @change="applyChange"
      />
    </v-layout>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="value"
      hide-actions
      no-data-text="Нет данных"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td
          v-for="column in columns"
          :key="column.name"
        >
          <span v-if="column.valueFn">{{ column.valueFn(props.item) }}</span>
          <span v-else>{{ props.item[column.name] }}</span>
        </td>
        <td class="justify-end layout px-0">
          <v-btn
            icon
            :disabled="!referenceComponent"
            small
            @click="edit(props.item)"
          >
            <v-icon color="grey darken-1">
              edit
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
            @click="remove(props.item)"
          >
            <v-icon color="grey darken-1">
              delete
            </v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
import * as referenceApi from "../../backend/referenceApi.js";

export default {
  props: [
    "value",
    "label",
    "resource",
    "columns",
    "searchPlaceholder",
    "referenceComponent",
    "dataTest",
  ],
  data() {
    return {
      menu: false,
      selected: null,
      loading: false,
    };
  },
  computed: {
    headers() {
      const headers = this.columns.map((c) => {
        return {
          text: c.title,
          sortable: false,
        };
      });
      headers.push({ text: "", sortable: false });
      return headers;
    },
  },
  created() {
    NestedEditorsEventBus.$on("create-" + this._uid, (createdId) => {
      const res = this.getReferenceList(createdId);
      const existItem = this.value.find((v) => v.id === res.data.Id);
      if (existItem) {
        this.value.splice(
          this.value.indexOf(existItem),
          1,
          this.convertItem(res.data),
        );
      }
    });
  },
  methods: {
    applyChange(value) {
      this.selected = value;
      this.add();
    },
    close() {
      this.selected = false;
      this.menu = false;
    },
    async add() {
      if (this.value.find((i) => i.id === this.selected.id)) {
        this.selected = null;
        this.close();
      } else {
        this.loading = true;
        const res = await this.getReferenceList(this.selected.id);
        this.value.push(this.convertItem(res.data));
        this.loading = false;
        this.close();
        this.$emit("change");
      }
    },
    convertItem(item) {
      const newItem = { id: item.Id };
      this.columns.forEach((c) => {
        const fieldName = c.data || c.name;
        const fieldNameSegments = fieldName.split(".");
        let fieldValue;
        fieldNameSegments.forEach((s) => {
          const formatedSegment = s.charAt(0).toUpperCase() + s.slice(1);
          if (fieldValue) {
            fieldValue = fieldValue[formatedSegment];
          } else {
            fieldValue = item[formatedSegment];
          }
        });
        newItem[c.name] = fieldValue;
      });
      return newItem;
    },
    remove(item) {
      var index = this.value.indexOf(item);
      if (index > -1) {
        this.value.splice(index, 1);
        this.$emit("change");
      }
    },
    edit(item) {
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.referenceComponent,
        params: { id: item.id.toString() },
        id: item.id,
      });
    },
    async getReferenceList(id) {
      const res = await referenceApi.getReferenceList(this.resource, id);
      return res;
    },
  },
};
</script>
